(function ($) {
	/* ---------------------------------------
		ページ遷移時にフェードイン・アウト
	--------------------------------------- */
	$(window).on('load', function () {
		$('body.under').removeClass('fadeout');
	});

	/* ---------------------------------------
		スクロール　フェードイン
	--------------------------------------- */
	$(window).on('load scroll', function () {
		$('.scrollin').each(function () {
			var position = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > position - windowHeight) {
				$(this).addClass('show');
			}
		});
	});

	/* ---------------------------------------
		ハンバーガーメニュー
	--------------------------------------- */
	$('.nav_btn').on('click', function () {
		$(this).toggleClass('active');
		$(this).parent('.header').toggleClass('open');
	});

	/* ---------------------------------------
		ヘッダー途中固定
	--------------------------------------- */
	$(function () {
		var $win = $(window),
			$main = $('.container'),
			$nav = $('.header'),
			$mv = $('.main_visual '),
			fixedClass = 'is-fixed';
		$win.on('load resize scroll', function () {
			var navHeight = $nav.outerHeight(),
				mvHeight = $mv.outerHeight();
			if ($('body').hasClass('home')) {
				var navPos = $win.height() - navHeight;
			} else if ($('body').hasClass('under')) {
				var navPos = mvHeight;
			}
			var windowWidth = window.innerWidth;
			var value = $(this).scrollTop();
			if (windowWidth > 999) {
				if (value > navPos) {
					$nav.addClass(fixedClass);
					$main.css('margin-top', navHeight);
				} else {
					if (!$('body').hasClass('popup_active')) {
						$nav.removeClass(fixedClass);
						$main.css('margin-top', '0');
					}
				}
			} else {
				$main.css('margin-top', '');
			}
		});
	});

	/* ---------------------------------------
		ページトップ
	--------------------------------------- */
	$(function () {
		var page_top = $('.page_top');
		page_top.click(function () {
			$('body, html').animate({ scrollTop: 0 }, 500);
			return false;
		});
		$(window).scroll(function () {
			if ($(this).scrollTop() >= 2000) {
				page_top.fadeIn();
			} else {
				page_top.fadeOut();
			}
		});
	});

	/* ---------------------------------------
		object スムーススクロール ページ内リンク
	--------------------------------------- */
	$(window).on('load', function () {
		var windowSize = $(window).width();
		if (windowSize >= 1000) {
			var headerHight = 70; //ヘッダの高さ
		} else {
			var headerHight = 35; //ヘッダの高さ
		}
		$('a[href^="#"]').click(function () {
			var target = $(this.hash);
			if (!target.length) return;
			var targetY = target.offset().top - headerHight;
			$('html,body').animate({ scrollTop: targetY }, 1000, 'swing');
			window.history.pushState(null, null, this.hash);
			return false;
		});
	});

	/* ---------------------------------------
		タブ切り替え
	--------------------------------------- */
	$(function () {
		$('.tab_menu li').click(function () {
			$('.active').removeClass('active');
			$(this).addClass('active');
			const index = $(this).index();
			$('.tab_content').eq(index).addClass('active');
		});
	});

	/* ---------------------------------------
		object fit ie
	--------------------------------------- */
	objectFitImages('.objectfit img, .img_trim img');

	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);

/* ---------------------------------------
	アコーディオン
--------------------------------------- */
(function ($) {
	$(".accordion-content").css("display", "none");
	$(".js-accordion-title").click(function () {
		$(".js-accordion-title").not(this).removeClass("open").next().slideUp(800);
		$(this).toggleClass("open").next().slideToggle(800);
	});

	/* ---------------------------------------
		別ページのアコーディオンをオープン
	--------------------------------------- */
	var hash = location.hash;
	var tab = jQuery('.accordion-item');
	if (hash.length) {
		//ハッシュがあったら
		if (hash.match(/#num/)) {
			//番号
			var tabName = Number(hash.slice(4.1) - 1);
			//遅延
			jQuery('.accordion-container').delay(100).queue(function () {
				//上部タブ部分
				console.log('test');
				tab.children('.js-accordion-title').removeClass('open');
				tab.children('.accordion-content').slideUp(800);
				tab.eq(tabName).children('.js-accordion-title').addClass('open');
				tab.eq(tabName).children('.accordion-content').slideDown(800);
			}); //queue
		} //if hash
	} //hash.length
})(jQuery);